import { BackendFetch } from '@hantera/portal-app'
import parseStatisticsJson from './statistics-json'
import type {
  Ingress,
  IngressIdStatistics,
  IngressStatisticsParams,
  ResourceLogging,
} from './ingresses.types'

export default function ingresses(fetch: BackendFetch) {
  return {
    async getAll(): Promise<Ingress[]> {
      const response = await fetch('/core/resources/ingresses', { method: 'GET' })

      if (!response.ok) {
        const errors = await response.errors()
        throw errors[0]
      }

      return parseStatisticsJson(await response.text())
    },

    async getStatistics(params?: IngressStatisticsParams): Promise<IngressIdStatistics[]> {
      const query = new URLSearchParams()
      if (params?.ingressId) query.set('ingressId', params.ingressId)
      if (params?.from) query.set('from', params.from.toISOString())
      if (params?.to) query.set('to', params.to.toISOString())

      const queryString = query.toString()
      const response = await fetch(
        queryString
          ? `/core/resources/ingresses/statistics?${queryString}`
          : '/core/resources/ingresses/statistics',
        { method: 'GET' },
      )

      if (!response.ok) {
        const errors = await response.errors()
        throw errors[0]
      }

      return parseStatisticsJson(await response.text()).ingresses ?? []
    },

    /**
     * PATCH rather than PUT: PUT runs ValidateIngress, which rejects any id beginning with
     * `apps/` — precisely the resources most often raised to `full` while debugging an installed
     * app. An omitted field is left unchanged; an explicit null clears the override.
     */
    async updateLogging(ingressId: string, patch: ResourceLogging): Promise<void> {
      const response = await fetch(`/core/resources/ingresses/${ingressId}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(patch),
      })

      if (!response.ok) {
        const errors = await response.errors()
        throw errors[0]
      }
    },
  }
}
